import { Fragment, useState, useEffect, useRef, useContext } from 'react';
import { history, IRouteComponentProps } from 'umi';
import { useSelector } from 'dva';
import { Typography } from 'iglooform';
import PcContext from '@/utils/context';
import { useIntl } from 'react-intl';
import { getCashHistory } from '../service';
import { BackButton } from '@/components/back-button/back-button';
import EmptyView from '@/components/empty-view/empty-view';
import './cash-history.less';
import { handleOnScroll } from '@/utils/common';
import SkeletonLoading from '@/components/skeleton-loading';
import CashOutHistoryItem from '@/components/cash-out-history-item/cash-out-history-item';

interface IHistory {
  list: CashHistoryProps[] | [];
  cursor: string;
}

const CashHistoryPage = ({ location }: IRouteComponentProps) => {
  const { formatMessage } = useIntl();
  const { isPc } = useContext(PcContext);
  const { query } = location;
  const { currentLang } = useSelector<ReduxState, GlobalState>(
    (state) => state.global,
  );
  const [isLoading, setLoading] = useState<boolean>(false);
  const [cashHistory, setCashHistory] = useState<IHistory>();
  const cursor = useRef('0');
  const handleGetHistory = (isScroll: boolean) => {
    if (window.location.pathname !== '/earnings/cash-history') return;
    if (cursor.current === '' || cursor.current === '1') return;
    if (cursor.current === '0' && isScroll) return;
    getCashHistory({ cursor: cursor.current, size: 10 })
      .then((res) => {
        if (res) {
          if (cursor.current === '0') {
            setCashHistory(res);
          } else {
            if (res.list) {
              setCashHistory((newObj: any) => {
                return {
                  list: [...newObj.list, ...res.list],
                  cursor: res.cursor,
                };
              });
            }
          }
          cursor.current = res.cursor;
        }
      })
      .finally(() => {
        setLoading(true);
      });
  };

  useEffect(() => {
    handleGetHistory(false);
    window.addEventListener(
      'scroll',
      handleOnScroll(() => handleGetHistory(true)),
    );
    return () => {
      window.removeEventListener(
        'scroll',
        handleOnScroll(() => handleGetHistory(true)),
      );
      cursor.current = '';
    };
  }, []);

  return (
    <Fragment>
      <BackButton handleClick={() => history.goBack()} />
      {isLoading ? (
        <>
          {isPc ? (
            <section className="history-title">
              <Typography level="h2">
                {formatMessage({ id: 'Cash out History' })}
              </Typography>
            </section>
          ) : (
            <div style={{ marginTop: '24px' }}></div>
          )}
          <div className="history-detail-container">
            {cashHistory && cashHistory.list && cashHistory.list.length ? (
              cashHistory.list.map((value: any) => (
                <CashOutHistoryItem
                  history={value}
                  currentLang={currentLang}
                  query={query}
                  isPc={isPc}
                />
              ))
            ) : (
              <EmptyView
                text={formatMessage({ id: 'You have no cash history now.' })}
              />
            )}
          </div>
        </>
      ) : (
        <div style={{ marginTop: '45px' }}>
          <SkeletonLoading />
        </div>
      )}
    </Fragment>
  );
};

export default CashHistoryPage;
